<template>
  <div>
    <v-slide-y-transition>
      <v-sheet
        v-if="rooms.data.length"
        class="mx-3 px-2 py-2 my-2"
        color="primary lighten-5"
        rounded
      >
        <div class="d-flex align-center">
          <div>
            <v-avatar :size="30" color="primary">
              <Icon
                icon="video-outline"
                color="white"
                class="pa-1"
              />
            </v-avatar>
          </div>
          <div class="ml-3">
            <div class="px-1">
              <small>
                Hey! Un Live-Shopping está ocurriendo
              </small>
            </div>
            <v-btn
              elevation="0"
              small
              class="text-center text-capitalize px-1"
              @click="goToRooms"
              text
              style="text-decoration: underline"
            >
              Ver transmisiones
            </v-btn>
          </div>
        </div>
      </v-sheet>
    </v-slide-y-transition>
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'

require('@/services/Rooms')

@Component({
  components: {
    Icon: () => import(/* webpackPrefetch: true */ '@/components/Icon.vue')
  },
  computed: {
    rooms () {
      return this.$store.state.rooms.list
    }
  },
  watch: {
    'rooms.data': function (value) {
      if (value.length > this.streamsCount) {
        setTimeout(() => {
          const popUpHandler = `ocularWidget.crossDomainMessage('widgetPlugin.goToRoute("rooms")')`
          this.$widget.showPopUpContent('<strong>Hey!</strong> Un Live-Shopping está ocurriendo', true, popUpHandler)
        }, 5000)
      }

      this.streamsCount = value.length
    }
  }
})
export default class Notification extends Vue {
  data () {
    return {
      streamsCount: 0
    }
  }

  mounted () {
    this.$rooms.indexStreamingRooms()
  }

  goToRooms () {
    this.$router.replace({ path: '/rooms' })
  }
}
</script>
